/**
 * QuotesPageV2 — redesigned Quotes list shell, port of the prototype's
 * `.screen-quotes` page-head (cms-redesign-mockup.html ~7353–7363).
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import QuotesTableV2 from './v2/QuotesTableV2';
import { PageHeader, Button } from '../../redesign';

const PlusSign = (
  <span style={{ fontSize: 16, lineHeight: 1 }} aria-hidden>+</span>
);

export default function QuotesPageV2() {
  const total = useSelector((s) =>
    Array.isArray(s.quotes.all_quotes) ? s.quotes.all_quotes.length : undefined,
  );
  const totalLabel = total != null ? `${total.toLocaleString()} total` : undefined;

  return (
    <div className="bg-bg min-h-full">
      <PageHeader
        eyebrow="Content Assets"
        title="Quotes"
        total={totalLabel}
        actions={
          <Link to="/quotes/add" className="no-underline">
            <Button variant="coral" leadingIcon={PlusSign}>
              Add Quote
            </Button>
          </Link>
        }
      />
      <QuotesTableV2 />
    </div>
  );
}
